import Vue from 'vue'

import './styles/quasar.styl'
import lang from 'quasar/lang/en-gb.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/mdi-v3/mdi-v3.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QDialog,
  QBtnDropdown,
  QInnerLoading,
  QSpinnerGrid,
  QTree,
  ClosePopup,
  QInput,
  QSelect,
  QMenu,
  QScrollArea,
  QAvatar,
  QSeparator,
  QCheckbox,
  QInfiniteScroll,
  QToggle,
  QTooltip,
  QBtnGroup,
  QSplitter,
  Ripple,
  Dialog,
  QBar,
  QTable,
  QTd,
  QTr,
  QTh,
  QSpace,
  QCard,
  QCardSection,
  QCardActions,
  Notify
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QDialog,
    QBtnDropdown,
    QInnerLoading,
    QSpinnerGrid,
    QTree,
    QInput,
    QSelect,
    QMenu,
    QScrollArea,
    QAvatar,
    QSeparator,
    QCheckbox,
    QInfiniteScroll,
    QToggle,
    QTooltip,
    QBtnGroup,
    QSplitter,
    QBar,
    QTable,
    QTd,
    QTr,
    QTh,
    QSpace,
    QCard,
    QCardSection,
    QCardActions
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Dialog,
    Notify
  },
  lang: lang
})
